<template>
  <div>
    <top title="申请记录" path="/home">
      <diaodu-menu slot="center"></diaodu-menu>
    </top>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <ly-time @timeObj='reTimeObj'></ly-time>
    <div id="mylist" style="top: 130px">
      <List
        v-for="(item, index) in listData"
        :key="index"
        @on-click="openXiangqing(item)"
      >
        <template slot="title">{{ item.user }} </template>
        <template slot="day"
          >创建：{{ utils.time(item.applyTime, "yymmddhhmm") }}</template
        >
        <template slot="des">
          订单编号：{{ item.applyId }} / 联系电话：{{ item.tel }} <br />
          预计用车：{{ utils.time(item.planUseTime, "yymmddhhmm") }}
        </template>
      </List>
    </div>
    <Modal
      v-model="xiangqing"
      title="详情"
      :mask-closable="false"
      width="90%"
      footer-hide
      fullscreen
    >
      <Detail :datas="datas">
        <Row slot="btn" style="margin-top: 20px">
          <!-- <Col span="8"><Button long>编辑</Button></Col>
          <Col span="8"><Button long>撤回</Button></Col> -->
          <Col span="24"
            ><Button
              long
              @click="send"
              :disabled="applyItem.taskStatus != 1"
              type="primary"
              >派车派司机</Button
            ></Col
          >
        </Row>
      </Detail>
    </Modal>
    <Modal v-model="openSend" fullscreen title="车辆调度" footer-hide>
      <send
        @dispatchData="reDispatchData"
        @cancel="reCancel"
        v-if="openSend"
      ></send>
    </Modal>
  </div>
</template>
<script>
import diaoduMenu from "../common/diaoduMenu.vue";
import axios from "axios";
import send from "./send";
export default {
  data() {
    return {
      openSend: false,
      listData: [],
      tab: [
        { title: "待调度", mark: 1 },
        { title: "已调度", mark: 2 },
        { title: "任务中", mark: 3 },
        { title: "已完成", mark: 4 },
        { title: "已撤单", mark: 5 },
      ],
      active: 0,
      now: 1,
      xiangqing: false,
      datas: [],
      applyItem: {},
      timeObj:{}
    };
  },
  components: {
    diaoduMenu,
    send,
  },
  methods: {
    //获取调度列表
    getList(t) {
      var params = {
        taskStatus: this.now,
        startTime: this.timeObj.start,
        endTime: this.timeObj.end,
      };
      axios({
        method: "post",
        url: axios.dispatch + "/dispatch/list",
        data: params,
      }).then((res) => {
        var data = res.data.data.dataList;
        this.listData = data;
      });
    },
    reTab(v) {
      this.now = v.mark;
      this.getList();
    },
    openXiangqing(row) {
      this.applyItem = row;
      this.xiangqing = true;
      this.datas = [
        {
          title: "单号",
          value: row.applyId,
        },
        {
          title: "用车人",
          value: row.user,
        },
        {
          title: "电话",
          value: row.tel,
        },
        {
          title: "单位名称",
          value: row.groupName,
        },
        {
          title: "开始地点",
          value: row.startAdd,
        },
        {
          title: "送达地点",
          value: row.endAdd,
        },
        {
          title: "预计用车",
          value: this.utils.time(row.planUseTime),
        },
        {
          title: "预计还车",
          value: this.utils.time(row.planReturnTime),
        },
        {
          title: "预计事由",
          value: row.des,
        },
      ];
    },
    send() {
      this.openSend = true;
    },
    reDispatchData(v) {
      let params = {
        applyId: this.applyItem.applyId,
        carId: v.carId,
        driverId: v.driverId,
        settleTypeId: v.settleTypeId,
      };
      axios({
        method: "post",
        url: axios.dispatch + "/dispatch/execute",
        data: params,
      }).then((res) => {
        if (res.data.code != 200) {
          this.$Message.error(res.data.message);
        } else {
          this.openSend = false;
          this.xiangqing = false;
          this.getList();
          //如果打勾，将该计费方式放到缓存,否则清理该缓存
        }
      });
    },
    reCancel() {
      this.openSend = false;
    },
    reTimeObj(v){
      this.timeObj=v;
      this.getList();
    }
  }
};
</script>
<style lang="">
.label {
  color: #999;
}
</style>


// WEBPACK FOOTER //
// src/components/dispatch/dispatch.vue